'use client';

import { useQuery } from '@tanstack/react-query';
import QueryKey from '../utils/queryKeys';
import { Identity } from '../types';

import { ethers } from 'ethers';
import { getShinkaiRegistryAddress } from '../contracts';
import { shinkaiRegistryAbi } from '../generated';

export const getIdentityData = async ({
  chainId,
  identity,
}: {
  chainId: number;
  identity: string;
}): Promise<Identity | null> => {
  // const rpcUrl = env.VITE_WAGMI_TRANSPORTS[chainId];

  // Base Sepolia
  if (chainId !== 84532) {
    throw new Error('Chain ID not supported');
  }
  const rpcUrl = 'https://sepolia.base.org';
  const provider = new ethers.JsonRpcProvider(rpcUrl);
  const contract = new ethers.Contract(
    getShinkaiRegistryAddress(),
    shinkaiRegistryAbi,
    provider,
  );
  const identityData = await contract.getIdentityData(identity);
  const [
    boundNft,
    stakedTokens,
    encryptionKey,
    signatureKey,
    routing,
    addressOrProxyNodes,
    delegatedTokens,
    lastUpdated,
  ] = identityData;

  const owner = await contract.ownerOf(identity);
  provider.destroy();
  return {
    nft: {
      tokenId: boundNft.toString(),
      owner: owner,
    },
    stakedTokens,
    encryptionKey,
    signatureKey,
    routing,
    addressOrProxyNodes:
      addressOrProxyNodes?.map((node: string) => node.toLowerCase()) ?? [],
    delegatedTokens,
    identity,
    identityRaw: identity,
    delegations: [],
    createdAt: lastUpdated.toString(),
    updatedAt: lastUpdated.toString(),
  };
};

export const useGetIdentityDataFromContract = (
  chainId: number,
  identity: string,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: [QueryKey.IDENTITY_FROM_CONTRACT, { identity }],
    queryFn: async () => {
      return getIdentityData({ chainId, identity });
    },
    enabled: !!chainId && !!identity && enabled,
    staleTime: 60000,
  });
};
